import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { emailLogsService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as emailLogsActions from './actions';


export function getEmailStatistics(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_EMAILSTATISTICS),
    mergeMap(({ payload }) => {
      return emailLogsService.getEmailLogs(payload)
        .pipe(
          map(res => emailLogsActions.getEmailStatisticsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}